import React, { useEffect } from "react";
import Menu from "./components/Menu";
import Bannar from "./components/Bannar";
import Box from "./components/Box";
import AboutUs from "./components/AboutUs";
import Activities from "./components/Activities";
import CounterSection from "./components/CounterSection";
import MomentsSection from "./components/Momentssection";
import MembersTestimonials from "./components/MembersTestimonials";
import PicturesGallery from "./components/PicturesGallery";
import Footer from "./components/Footer";

import {
  HashRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import History from "./pages/History";
import Area from "./pages/Area";
import Memberlogin from "./pages/Memberlogin";
import Gallery from "./pages/Gallery";
import Pension from "./pages/Pension";
import Sahakaranam from "./pages/Sahakaranam";
import Cultural from "./pages/Cultural";
import EducationalInitiatives from "./pages/EducationalInitiatives";
import CommunityEngagement from "./pages/CommunityEngagement";
import ThrissurChapterActivities from "./pages/ThrissurChapterActivities";
import ContactUs from "./pages/ContactUs";

import "./App.css";

/* 🔥 AUTO SCROLL TO TOP – SAME FILE */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HashRouter>
      {/* 🔥 AUTO SCROLL FIX */}
      <ScrollToTop />

      <>
        {/* ===== GLOBAL + FIXES ===== */}
        <style>{`
          html, body {
            width: 100%;
            max-width: 100%;
            overflow-x: hidden !important;
          }

          *, *::before, *::after {
            box-sizing: border-box;
          }

          img, iframe {
            max-width: 100%;
            height: auto;
            display: block;
          }

          section, nav, footer {
            max-width: 100%;
            overflow-x: hidden;
          }

          .info-boxes {
            width: 100%;
            max-width: 100%;
            margin: 0;
            padding: 0;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
          }

          @media (max-width: 576px) {
            .info-boxes {
              grid-template-columns: 1fr;
            }
          }
        `}</style>

        {/* ===== COMMON MENU ===== */}
        <Menu />

        {/* ===== ROUTES ===== */}
        <Routes>
          {/* HOME */}
          <Route
            path="/"
            element={
              <>
                <Bannar />
                <Box />
                <AboutUs />
                <Activities />
                <CounterSection />
                <MomentsSection />
                <MembersTestimonials />
                <PicturesGallery />
              </>
            }
          />

          <Route path="/history" element={<History />} />
          <Route path="/area" element={<Area />} />
          <Route path="/memberlogin" element={<Memberlogin />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/pension" element={<Pension />} />
          <Route path="/sahakaranam" element={<Sahakaranam />} />
          <Route path="/cultural" element={<Cultural />} />
          <Route
            path="/educationalinitiatives"
            element={<EducationalInitiatives />}
          />
          <Route path="/community" element={<CommunityEngagement />} />
          <Route
            path="/thrissurchapteractivities"
            element={<ThrissurChapterActivities />}
          />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>

        {/* ===== COMMON FOOTER ===== */}
        <Footer />
      </>
    </HashRouter>
  );
}

export default App;
